import { BRAND_RCI, BRAND_CEL } from '../constants';
import rciLabels from '../labels.json';
import celLabels from '../labelsCelebrity.json';

const getLabelsByBrand = brand => {
  switch (brand) {
    case BRAND_RCI.code:
      return rciLabels;
    case BRAND_CEL.code:
      return { ...rciLabels, ...celLabels };
    default:
      return rciLabels;
  }
};

export { getLabelsByBrand };
